import { Copy } from "lucide-react";
import { toast } from "sonner";

interface CopyableIdProps {
	/**
	 * The full ID value to copy
	 */
	value: string;
	/**
	 * Number of characters to show before truncating (default: 12)
	 */
	truncateAt?: number;
}

/**
 * Display a truncated ID with a copy button.
 * Clicking the button copies the full value to clipboard.
 */
export function CopyableId({ value, truncateAt = 12 }: CopyableIdProps) {
	const handleCopy = () => {
		navigator.clipboard.writeText(value);
		toast.success("Copied to clipboard");
	};

	const displayValue =
		value.length > truncateAt ? `${value.slice(0, truncateAt)}...` : value;

	return (
		<div className="flex items-center gap-2">
			<span className="font-mono text-xs">{displayValue}</span>
			<button
				type="button"
				onClick={handleCopy}
				className="text-base-content/40 hover:text-base-content transition-colors cursor-pointer"
				title="Copy full ID"
			>
				<Copy className="size-3.5" />
			</button>
		</div>
	);
}
